/**
 *  Tests to see if the browser can support passiveEvents. Currently, all browsers but IE11 support this
 *  thus the quippy warn statement. Passive Events are great for improving events that can cause jank such
 *  as scroll and resize events.
 *  See: https://developers.google.com/web/updates/2016/06/passive-event-listeners
 */

let warnedAboutPassiveEvents = false

export default function supportsPassiveEvents() {
	let passiveEventSupported = false
	try {
		const opts = Object.defineProperty({}, 'passive', {
			get() {
				passiveEventSupported = true
			}
		})
		window.addEventListener('test', null, opts)
		window.removeEventListener('test', null, opts)
	} catch (err) {
		if (!warnedAboutPassiveEvents) {
			warnedAboutPassiveEvents = true
			console.warn('Your current browser does not support passive events. Consider upgrading')
		}
	}

	return passiveEventSupported
}
